import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

class Slider {
    constructor(sliderEl, customConfig = {}) {
        this.sliderEl = sliderEl;
        this.defaultConfig = {
            modules: [Navigation, Pagination],
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            allowTouchMove: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: "auto",
                    spaceBetween: 0,
                },
            },
        };
        this.config = { ...this.defaultConfig, ...customConfig };
        this.init();
    }

    init() {
        new Swiper(this.sliderEl, this.config);
    }
}

export default Slider;
